import React from 'react';

interface PhotoViewerProps {
  photoUrl: string;
}

const PhotoViewer: React.FC<PhotoViewerProps> = ({ photoUrl }) => {
  return (
    <div className="w-full h-full flex items-center justify-center p-4">
      <img 
        src={photoUrl} 
        alt="Medical Record" 
        className="max-h-full max-w-full object-contain rounded-lg shadow-lg bg-black" 
      />
    </div>
  );
};

export default PhotoViewer;